<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import SummaryTab from './Part/SummaryTab.vue';
import ConfigTab from './Part/ConfigTab.vue';

export default {
  components: {
    Layout,
    PageHeader,
    SummaryTab,
    ConfigTab
  },
  data() {
    return {
      data: {},
      tabIndex: 0,
    };
  },
  created() {
    var vm = this;

    vm.syncTabFromRoute();
  },
  mounted() {
    var vm = this;

    vm.load();
  },
  watch: {
    tabIndex(newVal) {
      this.updateTabQuery(newVal);
    }
  },
  methods: {
    syncTabFromRoute() {
      var index = this.$route.query.tabIndex;

      if (index !== undefined) {
        this.tabIndex = Number(index);
      }
    },
    updateTabQuery(index) {
      const current = Number(this.$route.query.tabIndex);

      if (current !== index) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            tabIndex: index
          }
        });
      }
    },
    load() {
      var vm = this;

      vm.newData();
      vm.create();
    },
    newData() {
      var vm = this;

      var data = {
        id: null,
        ref_no: null,
        name: null,
        user: null
      };

      vm.data = Object.assign({}, data);
    },
    async create() {
      var vm = this;

      this.$loading.on('store_detail_create');
      try {
        var resp = await this.$api.Store.get(vm.$route.params.id);
        var data = resp.data.data;

        vm.data = data;

        this.$loading.off('store_detail_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    onUpdateStore() {
      var vm = this;

      vm.create();
    },
    onDeleteStore() {
      var vm = this;

      vm.$ac.refresh();
      vm.$router.back();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('store.title.detail')" :pageTitle="$t('store.title.list')" />

    <div class="profile-foreground position-relative mx-n4 mt-n4">
      <div class="profile-wid-bg">
      </div>
    </div>
    <div class="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
      <BRow class="g-4">
        <BCol cols="auto">
          <!-- <div class="avatar-xl">
            <div class="avatar-title bg-white rounded-circle">
              <img src="@/assets/images/cafeman/store.svg" class="avatar-lg">
            </div>
          </div> -->
          <div class="d-flex justify-content-center mb-3 mt-3">
            <div class="avatar-lg">
              <div
                class="avatar-title bg-light text-dark rounded-circle d-flex align-items-center justify-content-center">
                <i class="mdi mdi-storefront-outline" style="font-size: 50px;"></i>
              </div>
            </div>
          </div>
        </BCol>
        <BCol>
          <div class="p-2">
            <skeleton :loading="$loading.get('store_detail_create')" :schema="['col-3', 'col-1']">
              <h3 class="text-white mb-1">{{ data.name }}</h3>
              <p class="text-white text-opacity-75">{{ data.ref_no }}</p>
            </skeleton>
          </div>
        </BCol>
      </BRow>
    </div>
    <BRow>
      <BCol lg="12">
        <div>
          <BTabs nav-class="animation-nav profile-nav gap-1 gap-lg-2 pt-4 text-muted" pills v-model="tabIndex" lazy>
            <BTab class="nav-item pt-4" v-if="$ac.hasAccess('branch_full_access') || $ac.hasAccess('branch_list')">
              <template #title>
                <i class="mdi mdi-chart-line d-inline-block d-md-none"></i>
                <span class="d-none d-md-inline-block">{{ $t('store.label.summary') }}</span>
              </template>
              <SummaryTab :store="data" />
            </BTab>
            <BTab class="nav-item pt-4"
              v-if="$ac.hasAccess('store_full_access') || ($ac.hasAccess('store_create') && $ac.hasAccessStore(data.id))">
              <template #title>
                <i class="mdi mdi-cog-outline d-inline-block d-md-none"></i>
                <span class="d-none d-md-inline-block">{{ $t('store.tab.config') }}</span>
              </template>
              <ConfigTab :store="data" @onUpdate="onUpdateStore" @onDelete="onDeleteStore" />
            </BTab>
          </BTabs>
        </div>
      </BCol>
    </BRow>
  </Layout>
</template>